//域名统一管理
const BASEURL = {
    // devUrl: 'https://test-onlineprescription-api.yaojixin.com/',
    devUrl: "http://192.168.1.200:8090/",
    // devUrl: 'https://test-onlineprescription-api.yaojixin.com/',
    // devUrl: 'https://onlineprescription-api.yaojixin.com/',
    testUrl: "https://test-onlineprescription-api.yaojixin.com/",
    // devUrl: 'http://192.168.31.42:8090/', // 测试地址
    // productUrl: 'https://test-onlineprescription-api.yaojixin.com/',
    productUrl: "https://onlineprescription-api.yaojixin.com/", // 生产地址
};
const share_url = {
    devUrl: "http://test-onlineprescription-h5.yaojixin.com",
    // devUrl: 'http://onlineprescription-h5.yaojixin.com/#/register', // 生产地址
    testUrl: "https://test-onlineprescription-api.yaojixin.com/#/register",
    // devUrl: 'http://192.168.0.113:8083/#/register',
    // devUrl: 'http://localhost:8082/docMangeList',
    // productUrl: 'https://test-onlineprescription-h5.yaojixin.com/#/register', // 测试地址
    productUrl: "http://onlineprescription-h5.yaojixin.com/#/register", // 生产地址
};
const scan_url = {
    devUrl: "http://192.168.0.202:8090/h5-scan",
    // devUrl: 'http://test-onlineprescription-h5.yaojixin.com/h5-scan',
    testUrl: "https://test-onlineprescription-api.yaojixin.com/h5-scan",
    // productUrl: 'http://test-onlineprescription-h5.yaojixin.com/h5-scan', // 测试地址
    productUrl: "http://onlineprescription-h5.yaojixin.com/h5-scan", // 生产地址
};
let base_url = "";
let scanUrl = "";
let shareUrl = "";
switch (process.env.NODE_ENV) {
    case "development":
        base_url = BASEURL.devUrl;
        scanUrl = scan_url.devUrl;
        shareUrl = share_url.devUrl;
        break;
    case "test":
        base_url = BASEURL.testUrl;
        scanUrl = scan_url.testUrl;
        shareUrl = share_url.testUrl;
        break;
    case "production":
        base_url = BASEURL.productUrl;
        scanUrl = scan_url.productUrl;
        shareUrl = share_url.productUrl;
}
module.exports = {
    base_url,
    scanUrl,
    shareUrl,
};



// WEBPACK FOOTER //
// ./src/request/base.js